import { saveIAConfig } from "../core/cloudSync.js";
import { comprimirImagen } from "../core/storage.js";
import { today } from "../core/utils.js";
import { renderDocFormModal } from "./documentos.js";
import { showMaestroForm } from "./maestros.js";

import { BRAND, C, DOC_INFO, ESTADOS, ESTADO_COLOR, IA_MODELOS } from "../core/config.js";
import { state } from "../core/state.js";
import { supa } from "../core/supabaseClient.js";
import { btnStyle, escapeHTML, fmtCOP, genId, inputStyle, parseNumber } from "../core/utils.js";
import { render } from "../ui/app.js";

export function renderAsistenteIA() {
  const cfg = state.iaConfig || { model:"claude-sonnet-4-6" };
  const imagenes = state.iaImages || [];

  const header = `
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:9px;padding-bottom:10px;border-bottom:3px solid ${C.gold};">
      <div style="display:flex;gap:10px;align-items:center;">
        <img src="${window.LOGO}" alt="Aura" style="height:42px;object-fit:contain;"/>
        <div>
          <h2 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">🤖 Asistente IA</h2>
          <p style="margin:3px 0 0;color:${C.muted};font-size:11.5px;">Dicta o escribe instrucciones, o adjunta imágenes (RUT, Cámara de Comercio) para crear cotizaciones, productos y terceros</p>
        </div>
      </div>
    </div>
  `;

  const configHTML = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:10px;margin-bottom:18px;">
      <div style="font-size:11.5px;color:${C.muted};font-weight:700;letter-spacing:0.5px;margin-bottom:10px;">⚙️ CONFIGURACIÓN — ASISTENTE IA</div>
      <div style="display:flex;gap:10px;flex-wrap:wrap;align-items:flex-end;">
        <div>
          <label style="font-size:10px;color:${C.muted};font-weight:600;display:block;margin-bottom:3px;">Modelo</label>
          <select id="ia-modelo" style="${inputStyle}min-width:260px;">
            ${IA_MODELOS.map(m => `<option value="${m.value}" ${cfg.model===m.value?"selected":""}>${m.label}</option>`).join("")}
          </select>
        </div>
        <button data-action="ia-guardar-config" style="${btnStyle("#4C5FA8")}">💾 Guardar</button>
      </div>
      <div style="font-size:10px;color:${C.muted};margin-top:8px;">
        💡 El asistente usa la clave de Anthropic configurada del lado del servidor — no necesitas ingresar ninguna clave aquí.
      </div>
    </div>
  `;

  const imagenesHTML = imagenes.length === 0 ? "" : `
    <div style="display:flex;gap:10px;flex-wrap:wrap;margin-bottom:10px;">
      ${imagenes.map(img => `
        <div style="position:relative;width:90px;height:90px;border:1px solid ${C.border};border-radius:6px;overflow:hidden;">
          <img src="data:${img.mediaType};base64,${img.base64}" style="width:100%;height:100%;object-fit:cover;"/>
          <button data-action="ia-remove-image" data-id="${img.id}" style="position:absolute;top:2px;right:2px;background:rgba(15,23,42,.6);color:white;border:none;border-radius:50%;width:20px;height:20px;font-size:11.5px;cursor:pointer;line-height:1;">✕</button>
        </div>
      `).join("")}
    </div>
  `;

  const micActivo = !!state._iaListening;

  const inputHTML = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:10px;margin-bottom:18px;">
      <div style="font-size:11.5px;color:${C.muted};font-weight:700;letter-spacing:0.5px;margin-bottom:10px;">💬 INSTRUCCIÓN</div>
      <textarea id="ia-instruccion" oninput="state.iaInput=this.value" placeholder="Ej: Crea una cotización para Almacén La 80 con margen del 40%, 50 esferos azules y 20 termos.&#10;Ej: Crea un producto Termo metálico 1L, costo 18000, margen 35%.&#10;Ej: Crea un cliente con los datos de las imágenes del RUT y la cámara de comercio." style="${inputStyle}min-height:90px;resize:vertical;font-family:inherit;">${escapeHTML(state.iaInput||"")}</textarea>
      ${imagenesHTML}
      <div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;margin-top:10px;">
        <button data-action="ia-toggle-mic" style="${btnStyle(micActivo ? "#ef4444" : null, micActivo ? null : "secondary")}">${micActivo ? "⏹️ Detener dictado" : "🎤 Dictar por voz"}</button>
        <label style="${btnStyle(null,"secondary")}cursor:pointer;">
          🖼️ Adjuntar imagen
          <input type="file" accept="image/*" multiple onchange="handleIAImageFiles(event)" style="display:none;"/>
        </label>
        <button data-action="ia-limpiar" style="${btnStyle(null,"secondary")}">🧹 Limpiar</button>
        <button data-action="ia-enviar" ${state.iaLoading?"disabled":""} style="${btnStyle("#4C5FA8")}${state.iaLoading?"opacity:.6;cursor:wait;":""}">${state.iaLoading?"⏳ Procesando...":"✨ Enviar a la IA"}</button>
      </div>
      ${micActivo ? `<div style="font-size:10.5px;color:#ef4444;margin-top:6px;">🔴 Escuchando... habla ahora.</div>` : ""}
    </div>
  `;

  const errorHTML = state.iaError ? `
    <div style="background:#fef2f2;border:1px solid #fecaca;border-radius:6px;padding:10px;margin-bottom:18px;color:#b91c1c;font-size:12px;">
      ⚠️ ${escapeHTML(state.iaError)}
    </div>
  ` : "";

  const resultadoHTML = renderIAResultado();

  return `
    ${header}
    ${configHTML}
    ${inputHTML}
    ${errorHTML}
    ${resultadoHTML}
  `;
}

export function renderIAResultado() {
  const r = state.iaResultado;
  if (!r) return "";

  const accionLabels = {
    crear_producto: { titulo: "📦 Crear producto", color: "#f59e0b" },
    crear_tercero: { titulo: "👤 Crear tercero", color: "#2B4A82" },
    crear_cotizacion: { titulo: "📋 Crear cotización", color: C.blue },
    desconocido: { titulo: "❓ No se entendió la instrucción", color: C.muted }
  };
  const info = accionLabels[r.accion] || accionLabels.desconocido;

  let detalleHTML = "";
  if (r.accion === "crear_producto") {
    const p = r.producto || {};
    detalleHTML = `
      <table style="width:100%;font-size:11.5px;border-collapse:collapse;">
        <tr><td style="padding:4px 8px;color:${C.muted};">Nombre</td><td style="padding:4px 8px;font-weight:600;">${escapeHTML(p.nombre||"—")}</td></tr>
        <tr><td style="padding:4px 8px;color:${C.muted};">Referencia</td><td style="padding:4px 8px;">${escapeHTML(p.referencia||"—")}</td></tr>
        <tr><td style="padding:4px 8px;color:${C.muted};">Categoría</td><td style="padding:4px 8px;">${escapeHTML(p.categoria||"—")}</td></tr>
        <tr><td style="padding:4px 8px;color:${C.muted};">Unidad</td><td style="padding:4px 8px;">${escapeHTML(p.unidad||"—")}</td></tr>
        <tr><td style="padding:4px 8px;color:${C.muted};">Costo</td><td style="padding:4px 8px;">${p.costo?fmtCOP(p.costo):"—"}</td></tr>
        <tr><td style="padding:4px 8px;color:${C.muted};">Margen %</td><td style="padding:4px 8px;">${p.margen||"—"}</td></tr>
        <tr><td style="padding:4px 8px;color:${C.muted};">Precio de venta</td><td style="padding:4px 8px;">${p.precio_venta?fmtCOP(p.precio_venta):"—"}</td></tr>
      </table>
    `;
  } else if (r.accion === "crear_tercero") {
    const t = r.tercero || {};
    detalleHTML = `
      <table style="width:100%;font-size:11.5px;border-collapse:collapse;">
        <tr><td style="padding:4px 8px;color:${C.muted};">Tipo</td><td style="padding:4px 8px;font-weight:600;">${t.tipo==="proveedor"?"Proveedor":"Cliente"}</td></tr>
        <tr><td style="padding:4px 8px;color:${C.muted};">Nombre / Razón social</td><td style="padding:4px 8px;font-weight:600;">${escapeHTML(t.nombre||"—")}</td></tr>
        <tr><td style="padding:4px 8px;color:${C.muted};">NIT</td><td style="padding:4px 8px;">${escapeHTML(t.nit||"—")}</td></tr>
        <tr><td style="padding:4px 8px;color:${C.muted};">Contacto</td><td style="padding:4px 8px;">${escapeHTML(t.contacto||"—")}</td></tr>
        <tr><td style="padding:4px 8px;color:${C.muted};">Teléfono</td><td style="padding:4px 8px;">${escapeHTML(t.telefono||"—")}</td></tr>
        <tr><td style="padding:4px 8px;color:${C.muted};">Email</td><td style="padding:4px 8px;">${escapeHTML(t.email||"—")}</td></tr>
        <tr><td style="padding:4px 8px;color:${C.muted};">Dirección</td><td style="padding:4px 8px;">${escapeHTML(t.direccion||"—")}</td></tr>
        <tr><td style="padding:4px 8px;color:${C.muted};">Ciudad</td><td style="padding:4px 8px;">${escapeHTML(t.ciudad||"—")}</td></tr>
      </table>
    `;
  } else if (r.accion === "crear_cotizacion") {
    const cot = r.cotizacion || {};
    const clienteMatch = (state.data.clientes||[]).find(c => c.nombre && cot.cliente_nombre && c.nombre.toLowerCase().includes(String(cot.cliente_nombre).toLowerCase()));
    const items = cot.items || [];
    detalleHTML = `
      <table style="width:100%;font-size:11.5px;border-collapse:collapse;margin-bottom:10px;">
        <tr><td style="padding:4px 8px;color:${C.muted};">Cliente solicitado</td><td style="padding:4px 8px;font-weight:600;">${escapeHTML(cot.cliente_nombre||"—")}</td></tr>
        <tr><td style="padding:4px 8px;color:${C.muted};">Coincidencia en clientes</td><td style="padding:4px 8px;">${clienteMatch ? "✅ "+escapeHTML(clienteMatch.nombre) : "⚠️ No encontrado — deberás seleccionarlo/crearlo en el formulario"}</td></tr>
        <tr><td style="padding:4px 8px;color:${C.muted};">Margen indicado</td><td style="padding:4px 8px;">${cot.margen_pct ? cot.margen_pct+"%" : "—"}</td></tr>
      </table>
      ${items.length>0 ? `
        <div style="font-size:10.5px;color:${C.muted};font-weight:700;margin-bottom:4px;">ARTÍCULOS</div>
        <table style="width:100%;font-size:11.5px;border-collapse:collapse;">
          <tr style="color:${C.muted};">
            <td style="padding:4px 8px;">Artículo solicitado</td><td style="padding:4px 8px;">Coincidencia en catálogo</td><td style="padding:4px 8px;text-align:right;">Cant.</td>
          </tr>
          ${items.map(it => {
            const prod = (state.data.productos||[]).find(p => p.nombre && it.articulo && p.nombre.toLowerCase().includes(String(it.articulo).toLowerCase()));
            return `<tr style="border-top:1px solid ${C.border};">
              <td style="padding:4px 8px;">${escapeHTML(it.articulo||"—")}</td>
              <td style="padding:4px 8px;">${prod ? "✅ "+escapeHTML(prod.nombre) : "⚠️ No encontrado"}</td>
              <td style="padding:4px 8px;text-align:right;">${parseNumber(it.cantidad)||1}</td>
            </tr>`;
          }).join("")}
        </table>
      ` : `<div style="font-size:11.5px;color:${C.muted};">Sin artículos especificados — se abrirá la cotización en borrador para agregarlos manualmente.</div>`}
    `;
  }

  const accionBtn = r.accion !== "desconocido" ? `
    <button data-action="ia-aplicar-resultado" style="${btnStyle(info.color)}">➡️ Abrir formulario y continuar</button>
  ` : "";

  return `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:10px;margin-bottom:18px;">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;">
        <div style="font-size:12px;font-weight:700;color:${info.color};">${info.titulo}</div>
        <button data-action="ia-descartar-resultado" style="${btnStyle(null,"secondary",true)}">✕ Descartar</button>
      </div>
      ${r.mensaje ? `<div style="font-size:11.5px;color:${C.text};margin-bottom:10px;background:#f8fafc;padding:8px 10px;border-radius:7px;">💬 ${escapeHTML(r.mensaje)}</div>` : ""}
      ${detalleHTML}
      ${accionBtn ? `<div style="margin-top:12px;">${accionBtn}</div>` : ""}
    </div>
  `;
}

export function handleIAImageFiles(event) {
  const files = Array.from(event.target.files || []);
  if (files.length === 0) return;
  if (!state.iaImages) state.iaImages = [];

  let pendientes = files.length;
  files.forEach(file => {
    // 1400px conserva legible el texto de un RUT/Cámara de Comercio y reduce
    // varios MB de foto a ~100-200 KB antes de enviarla a la API.
    comprimirImagen(file, 1400, 0.85).then(dataUrl => {
      const base64 = String(dataUrl).split(",")[1] || "";
      state.iaImages.push({ id: genId(), nombre: file.name, mediaType: "image/jpeg", base64 });
    }).catch(err => {
      console.error("⚠️ No se pudo procesar la imagen adjunta:", err.message || err);
    }).finally(() => {
      pendientes--;
      if (pendientes === 0) render();
    });
  });
  event.target.value = "";
}

export function toggleIAMic() {
  const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SR) {
    alert("⚠️ Tu navegador no soporta dictado por voz. Usa Google Chrome o Microsoft Edge.");
    return;
  }
  if (state._iaListening && state._iaRecognition) {
    state._iaRecognition.stop();
    return;
  }
  const rec = new SR();
  rec.lang = "es-CO";
  rec.continuous = false;
  rec.interimResults = false;
  rec.onresult = (e) => {
    const texto = e.results[0][0].transcript;
    state.iaInput = (state.iaInput ? state.iaInput.trim() + " " : "") + texto;
    render();
  };
  rec.onerror = () => { state._iaListening = false; render(); };
  rec.onend = () => { state._iaListening = false; render(); };
  state._iaRecognition = rec;
  state._iaListening = true;
  render();
  rec.start();
}

export async function enviarInstruccionIA() {
  const instruccionInput = document.getElementById("ia-instruccion");
  if (instruccionInput) state.iaInput = instruccionInput.value;

  const instruccion = (state.iaInput || "").trim();
  const imagenes = state.iaImages || [];
  if (!instruccion && imagenes.length === 0) {
    alert("⚠️ Escribe una instrucción, dicta por voz o adjunta al menos una imagen.");
    return;
  }

  state.iaLoading = true;
  state.iaError = null;
  state.iaResultado = null;
  render();

  try {
    const content = [];
    imagenes.forEach(img => content.push({ type:"image", source:{ type:"base64", media_type: img.mediaType, data: img.base64 } }));
    content.push({ type:"text", text: instruccion || "Analiza las imágenes adjuntas (RUT y/o Cámara de Comercio) y extrae los datos del tercero." });

    const clientesCtx = (state.data.clientes||[]).map(c => c.nombre).filter(Boolean).slice(0, 200).join(", ");
    const productosCtx = (state.data.productos||[]).map(p => p.nombre).filter(Boolean).slice(0, 200).join(", ");

    const system = `Eres el asistente de voz/texto de ${BRAND.producto}, un ERP para empresas en Colombia.
Responde ÚNICAMENTE con un objeto JSON válido, sin texto adicional, sin backticks, sin bloques de código ni explicaciones fuera del JSON.

Esquema de respuesta exacto:
{
  "accion": "crear_producto" | "crear_tercero" | "crear_cotizacion" | "desconocido",
  "mensaje": "breve explicación en español para el usuario sobre lo que se va a hacer (o qué información falta si la acción es desconocido)",
  "producto": { "nombre":"", "referencia":"", "categoria":"", "unidad":"", "costo":0, "margen":0, "precio_venta":0 },
  "tercero": { "tipo":"cliente|proveedor", "nombre":"", "nit":"", "contacto":"", "telefono":"", "email":"", "direccion":"", "ciudad":"" },
  "cotizacion": { "cliente_nombre":"", "margen_pct":0, "items":[{"articulo":"","cantidad":1}], "notas":"" }
}

Reglas:
- Incluye solo el objeto correspondiente a la acción detectada; los demás puedes omitirlos o dejarlos vacíos.
- Si se adjuntan imágenes de RUT o Cámara de Comercio, o el usuario pide crear un tercero/cliente/proveedor, usa "crear_tercero" y extrae nombre o razón social, NIT (con dígito de verificación si aparece, formato NNNNNNNNN-D), dirección, ciudad, teléfono y correo si existen en la imagen o el texto. Si no se especifica, asume "tipo":"cliente".
- Si el usuario pide crear un producto, usa "crear_producto" con los datos indicados (nombre, costo, margen %, precio de venta, categoría, unidad, referencia).
- Si el usuario pide crear una cotización, usa "crear_cotizacion". Interpreta frases como "margen del 40%" como margen_pct=40. Si menciona productos con cantidades, inclúyelos en "items", usando el nombre más parecido de la lista de productos existentes cuando aplique (o el nombre tal cual lo dijo el usuario si no hay coincidencia).
- No inventes NITs, teléfonos, precios ni datos que no estén presentes en el texto o la imagen; deja esos campos vacíos o en 0.
- Si la instrucción es ambigua o no corresponde a ninguna de las acciones anteriores, usa "desconocido" y explica brevemente en "mensaje" qué información hace falta.

Clientes existentes (para intentar relacionar "cliente_nombre"): ${clientesCtx || "(ninguno registrado)"}
Productos existentes (para intentar relacionar "items.articulo"): ${productosCtx || "(ninguno registrado)"}`;

    // La llamada a la IA pasa por la Edge Function ia-proxy: la clave de Anthropic
    // vive como secreto del proyecto en Supabase, nunca en el navegador. supa.functions.invoke
    // adjunta automáticamente el JWT de la sesión, así que la función exige usuario autenticado.
    const { data, error } = await supa.functions.invoke("ia-proxy", {
      body: {
        model: state.iaConfig.model || "claude-sonnet-4-6",
        max_tokens: 1500,
        system,
        messages: [{ role: "user", content }]
      }
    });

    if (error) {
      const errBody = (error.context && typeof error.context.json === "function")
        ? await error.context.json().catch(() => null)
        : null;
      throw new Error((errBody && errBody.error) || error.message || "Error llamando al asistente de IA.");
    }
    if (data && data.error) throw new Error(data.error);

    const textBlock = (data.content || []).find(b => b.type === "text");
    if (!textBlock || !textBlock.text) throw new Error("La IA no devolvió una respuesta de texto procesable.");

    let raw = textBlock.text.trim();
    raw = raw.replace(/^```json\s*/i, "").replace(/^```\s*/,"").replace(/```\s*$/,"").trim();
    const parsed = JSON.parse(raw);
    state.iaResultado = parsed;
  } catch (err) {
    state.iaError = (err && err.message) ? err.message : String(err);
  } finally {
    state.iaLoading = false;
    render();
  }
}

export function getEstadosDesglose(docs, tipo) {
  const estados = ESTADOS[tipo] || {};
  const desglose = {};
  Object.keys(estados).forEach(key => { desglose[key] = 0; });
  docs.forEach(d => {
    const estado = d.estado || "borrador";
    if (desglose.hasOwnProperty(estado)) {
      desglose[estado]++;
    }
  });
  return desglose;
}

export function crearDesgloseCard(tipo, desglose) {
  const info = DOC_INFO[tipo];
  const estados = ESTADOS[tipo] || {};
  const total = Object.values(desglose).reduce((a,b) => a+b, 0);
  
  const filas = Object.entries(desglose)
    .filter(([key, count]) => count > 0)
    .map(([key, count]) => {
      const label = estados[key] || key;
      const color = ESTADO_COLOR[key] || C.muted;
      const porcentaje = total > 0 ? Math.round((count / total) * 100) : 0;
      return `
        <div style="display:flex;justify-content:space-between;align-items:center;padding:8px 0;border-bottom:1px solid ${C.border};">
          <div style="display:flex;align-items:center;gap:8px;flex:1;">
            <span style="display:inline-block;width:4px;height:12px;background:${color};border-radius:2px;"></span>
            <span style="font-size:11.5px;color:${C.muted};flex:1;">${escapeHTML(label)}</span>
          </div>
          <div style="display:flex;align-items:center;gap:8px;">
            <span style="font-weight:700;color:${C.text};min-width:30px;text-align:right;">${count}</span>
            <span style="font-size:10.5px;color:${C.muted};min-width:40px;text-align:right;">${porcentaje}%</span>
          </div>
        </div>
      `;
    })
    .join("");

  return `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;overflow:hidden;">
      <div style="display:flex;align-items:center;gap:8px;margin-bottom:9px;padding-bottom:10px;border-bottom:2px solid ${info.color}30;">
        <span style="font-size:17px;">${info.icon}</span>
        <div>
          <div style="font-size:12px;font-weight:700;color:${C.text};">${info.label}</div>
          <div style="font-size:10.5px;color:${C.muted};">${total} documentos</div>
        </div>
      </div>
      <div style="font-size:11.5px;">
        ${filas || '<div style="color:' + C.muted + ';padding:8px 0;">Sin documentos</div>'}
      </div>
    </div>
  `;
}

import { registerActions } from "../ui/actions.js";

registerActions({
  "ia-guardar-config": (d, el, e) => {{
      const modelSelect = document.getElementById("ia-modelo");
      if (!state.iaConfig) state.iaConfig = { model:"claude-sonnet-4-6" };
      if (modelSelect) state.iaConfig.model = modelSelect.value;
      saveIAConfig();
      render();
      return;
    }},
  "ia-toggle-mic": (d, el, e) => {{
      toggleIAMic();
      return;
    }},
  "ia-remove-image": (d, el, e) => {{
      state.iaImages = (state.iaImages || []).filter(img => img.id !== d.id);
      render();
      return;
    }},
  "ia-limpiar": (d, el, e) => {{
      state.iaInput = "";
      state.iaImages = [];
      state.iaResultado = null;
      state.iaError = null;
      render();
      return;
    }},
  "ia-enviar": (d, el, e) => {{
      enviarInstruccionIA();
      return;
    }},
  "ia-descartar-resultado": (d, el, e) => {{
      state.iaResultado = null;
      render();
      return;
    }},
  "ia-aplicar-resultado": (d, el, e) => {{
      const r = state.iaResultado;
      if (!r) return;

      if (r.accion === "crear_producto") {
        const p = r.producto || {};
        showMaestroForm("productos", {
          nombre: p.nombre || "",
          referencia: p.referencia || "",
          categoria: p.categoria || "",
          unidad: p.unidad || "",
          costo: p.costo || 0,
          margen: p.margen || 0,
          precio_venta: p.precio_venta || 0
        });
      } else if (r.accion === "crear_tercero") {
        const t = r.tercero || {};
        const key = t.tipo === "proveedor" ? "proveedores" : "clientes";
        showMaestroForm(key, {
          nombre: t.nombre || "",
          nit: t.nit || "",
          contacto: t.contacto || "",
          telefono: t.telefono || "",
          email: t.email || "",
          direccion: t.direccion || "",
          ciudad: t.ciudad || ""
        });
      } else if (r.accion === "crear_cotizacion") {
        const cot = r.cotizacion || {};
        const margen = parseNumber(cot.margen_pct) || 0;
        const clienteMatch = (state.data.clientes||[]).find(c => c.nombre && cot.cliente_nombre && c.nombre.toLowerCase().includes(String(cot.cliente_nombre).toLowerCase()));

        const items = (cot.items || []).map(it => {
          const prod = (state.data.productos||[]).find(p => p.nombre && it.articulo && p.nombre.toLowerCase().includes(String(it.articulo).toLowerCase()));
          const cantidad = parseNumber(it.cantidad) || 1;
          let precio_unitario = 0;
          if (prod) {
            const costo = parseNumber(prod.costo) || 0;
            precio_unitario = margen > 0 ? Math.round(costo * (1 + margen/100)) : (parseNumber(prod.precio_venta) || 0);
          }
          return {
            articulo: prod ? prod.nombre : (it.articulo || ""),
            descripcion: prod ? (prod.categoria || "") : "",
            referencia: prod ? (prod.referencia || "") : "",
            color: "", logo: "", impresion: "", tinta: "",
            cantidad,
            precio_unitario,
            total: cantidad * precio_unitario
          };
        });

        const notasPartes = ["Generado con Asistente IA"];
        if (margen) notasPartes.push(`margen ${margen}%`);
        if (cot.notas) notasPartes.push(cot.notas);

        state.editingDoc = {
          fecha: today(),
          cliente_id: clienteMatch ? clienteMatch.id : "",
          proveedor_id: "",
          items,
          notas: notasPartes.join(" · "),
          estado: "borrador"
        };
        state.editingTipo = "CT";
        renderDocFormModal();
      }

      // Limpiar el panel del asistente
      state.iaResultado = null;
      state.iaInput = "";
      state.iaImages = [];
      render();
      return;
    }},
});
